import WelcomeStep from "./WelcomeStep"
import BiologicalChildrenStep from "./BiologicalChildrenStep"
import MedicalHistoryStep from "./MedicalHistoryStep"
import ConditionsStep from "./ConditionsStep"
import FamilyConditionsStep from "./FamilyConditionsStep"
import CurrentlyTakingStep from "./CurrentlyTakingStep"
import SmokeDrink from "./SmokeDrinkStep"
import ExperiencingSymptomsStep from "./ExperiencingSymptomsStep"
import HeightWeightStep from "./HeightWeightStep"
import WhatKindOfJourneyAfabDecisionStep from "./WhatKindOfJourneyAfabDecisionStep"
import PastFertilityTreatmentStep from "./PastFertilityTreatmentStep"
import PregnancyMetWithObgynStep from "./PregnancyMetWithObgynStep"
import CyclesAreRegularStep from "./CyclesAreRegularStep"
import CycleDetailsStep from "./CycleDetailsStep"
import PeriodsPainfulStep from "./PeriodsPainfulStep"
import PeriodsPainfulDetailsStep from "./PeriodsPainfulDetailsStep"
import PregnantPreviouslyStep from "./PregnantPreviouslyStep"
import PregnantPreviouslyDetailsStep from "./PregnantPreviouslyDetailsStep"
import PelvicSurgeryDetailsStep from "./PelvicSurgeryDetailsStep"
import { Steps } from "../journey/step-library"
import ShowMedicalQuestionsDecisionStep from "./ShowMedicalQuestionsDecisionStep"
import AmabOrAfabDecisionStep from "./AmabOrAfabDecisionStep"

export enum Workflows {
  AMAB_MEDICAL_QUESTIONS = "AMAB",
  AFAB_MEDICAL_QUESTIONS = "AFAB"
}

export const medicalQuestionsSteps = [
  { name: Steps.SHOW_MEDICAL_QUESTIONS_DECISION, view: ShowMedicalQuestionsDecisionStep, decisionStep: true },
  { name: Steps.WELCOME, view: WelcomeStep },
  { name: Steps.BIOLOGICAL_CHILDREN, view: BiologicalChildrenStep },
  { name: Steps.MEDICAL_HISTORY, view: MedicalHistoryStep },
  { name: Steps.MEDICAL_CONDITIONS, view: ConditionsStep },
  { name: Steps.FAMILY_MEDICAL_CONDITIONS, view: FamilyConditionsStep },
  { name: Steps.CURRENTLY_TAKING, view: CurrentlyTakingStep },
  { name: Steps.SMOKE_DRINK, view: SmokeDrink },
  { name: Steps.CURRENTLY_EXPERIENCING, view: ExperiencingSymptomsStep },
  { name: Steps.HEIGHT_WEIGHT, view: HeightWeightStep },
  { name: Steps.WHAT_KIND_OF_JOURNEY_AFAB_DECISION, view: WhatKindOfJourneyAfabDecisionStep, decisionStep: true },
  { name: Steps.PREGNANCY_MET_WITH_OBGYN, view: PregnancyMetWithObgynStep },
  { name: Steps.PAST_FERTILITY_TREATMENT, view: PastFertilityTreatmentStep },
  { name: Steps.CYCLES_ARE_REGULAR, view: CyclesAreRegularStep },
  { name: Steps.CYCLE_DETAILS, view: CycleDetailsStep },
  { name: Steps.PERIODS_PAINFUL, view: PeriodsPainfulStep },
  { name: Steps.PERIODS_PAINFUL_DETAILS, view: PeriodsPainfulDetailsStep },
  { name: Steps.PREGNANT_PREVIOUSLY, view: PregnantPreviouslyStep },
  { name: Steps.PREGNANT_PREVIOUSLY_DETAILS, view: PregnantPreviouslyDetailsStep },
  { name: Steps.PELVIC_SURGERY, view: PelvicSurgeryDetailsStep },
  { name: Steps.AMAB_OR_AFAB_DECISION, view: AmabOrAfabDecisionStep, decisionStep: true }
]

//prettier-ignore
export const medicalQuestionsFlow = [
  { forStep: Steps.SHOW_MEDICAL_QUESTIONS_DECISION, memberSelects: "NO", goto: Steps.ANYTHING_ELSE },
  { forStep: Steps.SHOW_MEDICAL_QUESTIONS_DECISION, memberSelects: "YES", goto: Steps.WELCOME },
  { forStep: Steps.WELCOME, memberSelects: "", goto: Steps.AMAB_OR_AFAB_DECISION },
  { forStep: Steps.AMAB_OR_AFAB_DECISION, memberSelects: "AMAB", goto: Steps.BIOLOGICAL_CHILDREN },
  { forStep: Steps.AMAB_OR_AFAB_DECISION, memberSelects: "AFAB", goto: Steps.WHAT_KIND_OF_JOURNEY_AFAB_DECISION },

  { forStep: Steps.BIOLOGICAL_CHILDREN, memberSelects: "", goto: Steps.MEDICAL_HISTORY },
  { forStep: Steps.MEDICAL_CONDITIONS, memberSelects: "", goto: Steps.FAMILY_MEDICAL_CONDITIONS },
  { forStep: Steps.FAMILY_MEDICAL_CONDITIONS, memberSelects: "", goto: Steps.CURRENTLY_TAKING },
  { forStep: Steps.CURRENTLY_TAKING, memberSelects: "", goto: Steps.SMOKE_DRINK },
  { forStep: Steps.SMOKE_DRINK, memberSelects: "", goto: Steps.CURRENTLY_EXPERIENCING },
  { forStep: Steps.CURRENTLY_EXPERIENCING, memberSelects: "", goto: Steps.HEIGHT_WEIGHT },
  { forStep: Steps.HEIGHT_WEIGHT, memberSelects: "", goto: Steps.ANYTHING_ELSE },

  { forStep: Steps.WHAT_KIND_OF_JOURNEY_AFAB_DECISION, memberSelects: "PREGNANT", goto: Steps.PREGNANCY_MET_WITH_OBGYN },
  { forStep: Steps.WHAT_KIND_OF_JOURNEY_AFAB_DECISION, memberSelects: "TRY_PREGNANT", goto: Steps.CYCLES_ARE_REGULAR },
  { forStep: Steps.WHAT_KIND_OF_JOURNEY_AFAB_DECISION, memberSelects: "PAST_FERTILITY_TREATMENT", goto: Steps.PAST_FERTILITY_TREATMENT },
  { forStep: Steps.PREGNANCY_MET_WITH_OBGYN, memberSelects: "", goto: Steps.CYCLES_ARE_REGULAR },
  { forStep: Steps.PAST_FERTILITY_TREATMENT, memberSelects: "", goto: Steps.CYCLES_ARE_REGULAR },
  { forStep: Steps.CYCLES_ARE_REGULAR, memberSelects: "NO", goto: Steps.CYCLE_DETAILS },
  { forStep: Steps.CYCLES_ARE_REGULAR, memberSelects: "YES", goto: Steps.PERIODS_PAINFUL },
  { forStep: Steps.CYCLES_ARE_REGULAR, memberSelects: "", goto: Steps.PERIODS_PAINFUL },
  { forStep: Steps.CYCLE_DETAILS, memberSelects: "", goto: Steps.PERIODS_PAINFUL },
  { forStep: Steps.PERIODS_PAINFUL, memberSelects: "YES", goto: Steps.PERIODS_PAINFUL_DETAILS },
  { forStep: Steps.PERIODS_PAINFUL, memberSelects: "NO", goto: Steps.PREGNANT_PREVIOUSLY },
  { forStep: Steps.PERIODS_PAINFUL, memberSelects: "", goto: Steps.PREGNANT_PREVIOUSLY },
  { forStep: Steps.PERIODS_PAINFUL_DETAILS, memberSelects: "", goto: Steps.PREGNANT_PREVIOUSLY },
  { forStep: Steps.PREGNANT_PREVIOUSLY, memberSelects: "YES", goto: Steps.PREGNANT_PREVIOUSLY_DETAILS },
  { forStep: Steps.PREGNANT_PREVIOUSLY, memberSelects: "NO", goto: Steps.MEDICAL_HISTORY },
  { forStep: Steps.PREGNANT_PREVIOUSLY, memberSelects: "", goto: Steps.MEDICAL_HISTORY },
  { forStep: Steps.PREGNANT_PREVIOUSLY_DETAILS, memberSelects: "", goto: Steps.MEDICAL_HISTORY },
  { forStep: Steps.MEDICAL_HISTORY, memberSelects: "", goto: Steps.MEDICAL_CONDITIONS },
  { forStep: Steps.MEDICAL_HISTORY, memberSelects: "PELVIC_ABDOMEN_SURGERY", goto: Steps.PELVIC_SURGERY },
  { forStep: Steps.PELVIC_SURGERY, memberSelects: "", goto: Steps.MEDICAL_CONDITIONS }
]
